import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliLink, LiliLinkSize, LiliLinkType } from '@lili/lili-frontend-common';
import noTransactionsYet from '../../assets/icons/svg/large-icons/ic-large-categorization-reload.svg';
import { TransactionRow } from '../../pages/DashboardFacelift/components/TransactionRow';
import { LiliTransaction } from '../../pages/TransactionsFacelift/types/lili-transaction';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/svg/shared/ic-shared-right-arrow.svg';

interface LatestTransactionsProps {
  data: LiliTransaction[];
  isLoading: boolean;
  navPath: string;
  handleShowAll?: () => void;
  showMore?: boolean;
}

const NewLatestTransactions = ({ data, isLoading, navPath, handleShowAll, showMore }: LatestTransactionsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='w-full h-full'>
      <div className='flex items-center h-[70px] px-[32px] border-b border-b-outline-primary-bw-03'>
        <Heading.H9 fontWeight={FontWeight.SEMIBOLD}>{t('LATEST_TRANSACTIONS_HEADER')}</Heading.H9>
      </div>

      <div className='flex flex-col justify-between w-full h-[88%] overflow-scroll pb-[32px] px-[20px]'>
        <div>
          {!isLoading && data.length === 0 && (
            <div className='flex flex-col justify-center items-center gap-6 mt-[5rem]'>
              <img className='w-[9.5rem] h-[9.875rem]' src={noTransactionsYet} alt='no-transactions' />
              <span className='text-sm font-metric text-bw06 text-center px-14'>
                {t('LATEST_TRANSACTIONS_NO_TRANSACTIONS')}
              </span>
            </div>
          )}
          {!isLoading &&
            data.length > 0 &&
            data.map((transaction) => (
              <TransactionRow
                onClick={() => navigate(navPath)}
                liliTransaction={transaction}
                key={transaction?.transactionId}
              />
            ))}
          {isLoading && (
            <div className='w-full h-full overflow-hidden px-[22px]'>
              <Skeleton className='my-4' count={8} />
            </div>
          )}
        </div>
        {showMore && (
          <LiliLink
            id='latestTransactionsBtn'
            href='#'
            onClick={() => {
              if (handleShowAll) handleShowAll();
              else navigate(navPath);
            }}
            type={LiliLinkType.SECONDARY_QUITE}
            title={t('LATEST_TRANSACTIONS_SHOW_ALL')}
            rightIcon={<RightArrowIcon className='text-text-brand-primary' />}
            size={LiliLinkSize.SMALL}
            className='self-end'
          />
        )}
      </div>
    </div>
  );
};

export default NewLatestTransactions;
